import axios from "axios";
import { NOTIFICATION_URL } from "utils/constants";

export const connectNotification = async (fcmToken, userToken) => {
  try {
    const response = await axios({
      method: "post",
      baseURL: NOTIFICATION_URL,
      url: "/notification",
      data: JSON.stringify({
        token: fcmToken,
        type: "web",
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userToken,
      },
    });

    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, data: null };
  }
};

export const disconnectNotification = async (fcmToken, userToken) => {
  const response = await axios({
    method: "delete",
    baseURL: NOTIFICATION_URL,
    url: "/notification",
    data: JSON.stringify({
      token: fcmToken,
      type: "web",
    }),
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userToken,
    },
  });
  return response.data;
};
